import React, { useEffect, useState } from 'react'
import styles from "./Dashboardheader.module.css"
import { HashLink } from 'react-router-hash-link';
import { Link, useParams } from 'react-router-dom'
import { scrollWithDelayOffset } from '../../Utils/ScrollUnits';
import ThemeButton from '../../Themes/ThemeButton'
import { useTheme } from '../../Themes/ThemeContext'
import { divide } from 'lodash'

const Dashboardheader = () => {
    const { theme } = useTheme();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 770);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 770) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
                setMobileMenuOpen(false);
            }
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);




    return (
        <div className={styles.dashboardnavbarcontainer}>
            <Link to={"/home"} tabIndex={0}>
                {
                    theme === "dark" ? (
                        <img alt='editLatex logo' src={process.env.PUBLIC_URL + "/NewPages/Dashboard/darklogo.png"} />
                    ) :
                        <img alt="editLatex logo" src={process.env.PUBLIC_URL + "/NewPages/Homepage/TransformaLogo.png"} />
                }
            </Link>
            {
                !isMobile && (<>
                    <div className={styles.dashboardnavbarlinks}>
                        <ul>
                            <li><HashLink smooth scroll={scrollWithDelayOffset} to="/home#features">Features</HashLink></li>
                            <li><Link to={"/templates"}>Templates</Link></li>
                            <li><HashLink smooth scroll={scrollWithDelayOffset} to="/home#pricing">Pricing</HashLink></li>
                            <li><HashLink smooth scroll={scrollWithDelayOffset} to="/home#faqs">FAQS</HashLink></li>
                        </ul>
                    </div>
                </>)
            }
            {
                isMobile && (
                    <>
                        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>

                            <svg width="30" height="30" viewBox="0 0 100 80" fill="currentColor">
                                <rect width="100" height="10"></rect>
                                <rect y="30" width="100" height="10"></rect>
                                <rect y="60" width="100" height="10"></rect>
                            </svg>
                        </button>
                    </>
                )
            }
            {
                (isMobile && mobileMenuOpen) && (
                    <div className={styles.mobile_menu_links}>
                        <ul>
                            <li><HashLink smooth to="/home#features" scroll={scrollWithDelayOffset}>Features</HashLink></li>
                            <li><Link to={"/templates"}>Templates</Link></li>
                            <li><HashLink smooth to="/home#pricing" scroll={scrollWithDelayOffset}>Pricing</HashLink></li>
                            <li><HashLink smooth to="/home#faqs" scroll={scrollWithDelayOffset}>FAQS</HashLink></li>

                        </ul>
                    </div>
                )
            }

        </div>
    )
}

export default Dashboardheader